// Event bootstrap. Resolves the QR slug (?event=<slug>) to an event id when live mode
// (VITE_USE_API=true) is on; otherwise stays in mock mode so the app runs with no backend.
import { createContext, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import { USE_API, eventSlug } from "./config";
import { api } from "./api";

interface EventState {
  /** null in mock mode or while resolving. */
  eventId: string | null;
  coupleNames: string | null;
  /** true once we have a real eventId and live mode is on. */
  live: boolean;
}

const EventContext = createContext<EventState>({ eventId: null, coupleNames: null, live: false });

export function EventProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<EventState>({ eventId: null, coupleNames: null, live: false });

  useEffect(() => {
    if (!USE_API) return;
    let cancelled = false;
    api
      .resolveEvent(eventSlug())
      .then((info) => {
        if (!cancelled) setState({ eventId: info.eventId, coupleNames: info.coupleNames, live: true });
      })
      .catch((err) => {
        console.warn("Event resolve failed; staying in mock mode:", err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <EventContext.Provider value={state}>{children}</EventContext.Provider>;
}

export function useEvent(): EventState {
  return useContext(EventContext);
}
